import { UI_RESOURCE_ART, UI_ROLE_ART, UI_CHASSIS_ART, UI_STAT_ART, type Role, type Chassis } from "@zend/content";
import type { CSSProperties } from "react";
import { AssetIcon } from "./Icon.js";

interface IconSize { size?: number; style?: CSSProperties; label?: string; }

/** Compact content imagery uses exactly the same sealed pipeline files as larger previews. */
export function GameIcon({ id, size = 18, style, label = "" }: IconSize & { id: string }) {
  return <AssetIcon id={id} size={size} alt={label} style={{ display: "inline-block", verticalAlign: "-0.22em", flexShrink: 0, ...style }} />;
}

export function ResourceIcon({ resource, ...props }: IconSize & { resource: keyof typeof UI_RESOURCE_ART }) {
  return <GameIcon id={UI_RESOURCE_ART[resource]} {...props} />;
}

export function RoleIcon({ role, ...props }: IconSize & { role: Role }) {
  return <GameIcon id={UI_ROLE_ART[role]} {...props} />;
}

export function ChassisIcon({ chassis, ...props }: IconSize & { chassis: Chassis }) {
  return <GameIcon id={UI_CHASSIS_ART[chassis]} {...props} />;
}

export function StatIcon({ stat, ...props }: IconSize & { stat: keyof typeof UI_STAT_ART }) {
  return <GameIcon id={UI_STAT_ART[stat]} {...props} />;
}
